<template>
  <div class="inputItemWrapper">
    <div
      v-for="item of itemList"
      :key="item.value"
      class="inputItemInnerWrapper"
      :class="{
        isPc: !isSp,
        isConfirmationScreenWrapper: isConfirmationScreen,
        flexAutoSecond: flexAutoNum === 2,
      }"
    >
      <input
        :id="item.value"
        v-model="handleSelectValue"
        class="inputItem"
        type="radio"
        :name="questionId"
        :value="item.value"
        :disabled="disabled"
        autocomplete="off"
      />
      <label
        class="inputItemLabel"
        :class="{ isPc: !isSp, disabled: disabled, isConfirmationScreen: isConfirmationScreen }"
        :for="item.value"
      >
        {{ item.text || item.name }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButton',
  model: {
    prop: 'selectValue',
    event: 'change',
  },
  props: {
    questionId: {
      type: String,
      required: true,
    },
    placeholderValue: {
      type: String,
      required: false,
      default: '',
    },
    selectValue: {
      type: String,
      default: '',
    },
    itemList: {
      type: Array,
      required: true,
      default: () => [],
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    isConfirmationScreenFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    flexAutoNum: {
      type: Number,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    handleSelectValue: {
      get() {
        return this.selectValue;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
    /**
     * 資料請求確認画面、 予約確認画面時true
     */
    isConfirmationScreen() {
      return Boolean(this.isConfirmationScreenFlg);
    },
  },
  methods: {
    onBlur(event) {
      // 単純emit
      this.$emit('blur', event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

// select自体には擬似要素がつかないのでWrapperする
.inputItemWrapper {
  width: 100%;
  font-size: $text-size-paragraph2;
  line-height: 48px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .inputItemInnerWrapper {
    @media screen and (orientation: landscape) {
      width: calc(100% / 3 - 19.3px);
    }

    &.isPc {
      min-width: 138px;
    }

    &.isConfirmationScreenWrapper {
      margin-bottom: 8px;
      margin-left: 0;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    &:first-child {
      margin-left: 0;
    }

    .inputItem {
      display: none;
    }

    .inputItemLabel {
      position: relative;
      display: flex;
      align-items: center;
      border: $border-sapuri-white-light;
      border-radius: 6px;
      padding: 14px 11px 14px 39px;
      height: 48px;
      box-sizing: border-box;

      &.disabled {
        color: $color-text-spot-caption;
        background-color: $color-background-primary-third;
      }

      &::before {
        position: absolute;
        box-sizing: border-box;
        top: 13px;
        left: 10px;
        content: '';
        height: 20px;
        width: 20px;
        border: $border-sapuri-white-light;
        border-radius: 50%;
      }

      &.disabled::before {
        background-color: $color-background-primary-third;
      }

      &.isPc {
        &::before {
          top: 14px;
          left: 12px;
        }

        &.isConfirmationScreen {
          width: 396px;
          margin-left: 32px;
        }

        &.isConfirmationScreen::before {
          left: 16px;
        }
      }

      &.isConfirmationScreen {
        padding: 15px 16px 15px 44px;
        line-height: 1.3;
        font-size: 14px;
      }
    }

    input[type='radio']:checked + .inputItemLabel {
      border-color: $color-action-primary;
      background: $color-background-secondry-light;

      &.disabled {
        border: $border-sapuri-white-light;
        background-color: $color-background-primary-third;
      }

      &::before {
        background: $color-action-primary;
        border: none;
      }

      &::after {
        position: absolute;
        top: 19px;
        left: 16px;
        content: '';
        height: 8px;
        width: 8px;
        background: $color-background-primary-third-light;
        border-radius: 50%;
      }

      &.disabled::before {
        border: $border-sapuri-white-light;
        background-color: $color-background-primary-third;
      }

      &.disabled::after {
        background-color: $color-background-primary-third-dark;
      }

      &.isPc {
        &::after {
          top: 20px;
          left: 18px;
        }

        &.isConfirmationScreen::after {
          left: 22px;
        }
      }
    }
  }

  .flexAutoSecond {
    &:nth-child(-n + 2) {
      @media screen and (min-width: 338px) {
        flex: auto;
      }
    }

    @media screen and (orientation: landscape) {
      flex: auto;
      width: auto;
    }
  }
}
</style>
